import React, { useState, useEffect } from 'react';
import ReactTooltip from "react-tooltip";
import { motion } from 'framer-motion';
import { images } from '../../constants';

import { AppWrap, MotionWrap } from '../../wrapper';

import './Skills.scss';

const skill = [
  {
    name: 'HTML', 
    icon: `${images.html}`,
    bgColor: '#FFDFE9',
  },
  {
    name: 'CSS', 
    icon: `${images.css}`,
    bgColor: '#D2E8FE',
  },
  {
    name: 'SASS', 
    icon: `${images.sass}`,
    bgColor: '#FFDFE9',
  },
  {
    name: 'JavaScript', 
    icon: `${images.javascript}`,
    bgColor: '#FFE8E3',
  },
  {
    name: 'Illustrator', 
    icon: `${images.illustrator}`,
    bgColor: '#FFE8E3',
  },
  {
    name: 'Indesign', 
    icon: `${images.indesign}`,
    bgColor: '#FFDFE9',
  },
  {
    name: 'Photoshop', 
    icon: `${images.photoshop}`,
    bgColor: '#D2E8FE',
  },
  {
    name: 'Figma', 
    icon: `${images.figma}`,
    bgColor: '#E6FEF9',
  },
  {
    name: 'Git', 
    icon: `${images.git}`,
    bgColor: '#FFE8E3',
  },
  {
    name: 'Slack', 
    icon: `${images.slack}`,
    bgColor: '#E6FEF9',
  }
];

const work = [
  {
    year: '2022',
    name: 'Junior Graphic Designer', 
    company: 'AMPLEXOR Adriatic LLC',
    desc: 'I work as a Graphic Designer for Amplexor company. My tasks are designing a booklet, banners, envelopes, social media posts, and other graphics.'
  },
  {
    year: `. . . . .`,
    name: 'Junior UX/UI Designer', 
    company: 'Aconno – IoT made easy',
    desc: 'I worked at Aconno company for five months. I worked in a team of three designers, and my main task of mine was to redesign their old website and create five new landing pages for brother company Troido. Also, aside from that, I worked weekly on posts for social media platforms, like LinekedIn and Instagram.'
  },
  {
    year: `. . . . .`,
    name: 'Web Design – Freelance', 
    company: 'Hair Salon Tina',
    desc: 'I worked for Hair Salon Tina as a designer and developer. I made UI Design for the website and after that, I developed it. Also, I photographed the salon and edited photos, and optimized them for the website.'
  },
  {
    year: `. . . . .`,
    name: 'Graphic Design – Freelance', 
    company: 'Sport Club Druzilovec (SUD)',
    desc: 'I worked in graphics design for Sport Club Druzilovec. I made a logo, tagline, and visit card.'
  },
  {
    year: '2020',
    name: 'Web Designer - Erasmus+', 
    company: 'Antidoto28 Diseño Moda Serigrafia',
    desc: 'I was working in CMS WordPress. In which I updated the content and created the new one. Also, I worked on posters for their open days.'
  },
  {
    year: '. . . . .',
    name: 'Editor of the digital school newspaper', 
    company: 'Zabok School of Art, Design, Graphics, and Clothing: Tabula nova',
    desc: 'I was writing content for a digital school sheet Tabula nova.'
  }
];


const Skills = () => {

  const [experience, setExperience] = useState([]);
  const [skills, setSkills] = useState([]);


  return (
    <>
      <h2 className='head-text'>Skills & <span>Experience</span></h2>

      <div className='app__skills-container'>
        <motion.div className='app__skills-list'>
          {skill.map((skill) => (
            <motion.div
              whileInView={{opacity: [0, 1]}}
              transition={{duration: 0.5}}
              className='app__skills-item app__flex'
              key={skill.name}
            >
              <div className='app__flex' style={{backgroundColor: skill.bgColor}}>
                <img src={(skill.icon)} alt={skill.name} />
              </div>
              <p className='p-text'>{skill.name}</p>
            </motion.div>
          ))}
        </motion.div>

        <motion.div className='app__skills-exp'>
            {work.map((experience) => (
              <motion.div
               className='app__skills-exp-item'
               key={experience.year}
              >
                <div className='app__skills-exp-year'>
                  <p className="bold-text">{experience.year}</p>
                </div>
                
                <motion.div className='app__skills-exp-works'>
                  <>
                  <motion.div
                    whileInView={{opacity: [0, 1]}}
                    transition={{duration: 0.5}}
                    className='app__skills-exp-work'
                    data-tip
                    data-for={experience.name}
                    key={experience.name}
                  >
                    <h4 className='bold-text'>{experience.name}</h4>
                    <p className='p-text'>{experience.company}</p>
                  </motion.div>

                  <ReactTooltip
                    id={experience.name}
                    effect='solid'
                    arrowColor='#080831'
                    className='skills-tooltip'
                  >
                    {experience.desc}
                  </ReactTooltip>
                  </> 
                </motion.div>

              </motion.div>

            ))}

        </motion.div>
      </div>
    </>
  );
}

export default AppWrap(
  MotionWrap(Skills, 'app__skills'), 
  'skills', 
  );
